import React from "react"
import SavedArtistsContainer from "../../../containers/explore/SavedArtists"

const SavedArtists = () => <SavedArtistsContainer />

export default SavedArtists
